module.exports = __webpack_public_path__ + "static/img/a7.3546c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a7.jpg
// module id = LgD7
// module chunks = 0